import angular from 'angular';
import ngAnimate from 'angular-animate';
import uiRouter from 'angular-ui-router';
import uiBootstrap from 'angular-ui-bootstrap';
import uiBootstrapOnly from 'bootstrap-css-only';
import Components from './components/components';
import Pages from './pages/pages';
import Services from './services/services';
import Directives from './directives/directives';
import AuthService from './services/auth.service';
import AppComponent from './app.component';
import ngNotify from 'angular-ui-notification';
import ngSanitize from 'angular-sanitize';
import ngCsv from 'ng-csv';
import 'angular-validation';
import 'angular-validation/src/rule';
import 'angular-moment-picker';
import 'angular-moment-picker/dist/angular-moment-picker.min.css';
import ngMoment from 'angular-moment';
import momentTz from 'moment-timezone';
import 'angular-file-upload';
import 'angular-bootstrap-confirm';
import 'angular-filter';
import 'animate.css';
import 'font-awesome/scss/font-awesome.scss';
import 'angular-loading-bar';
import 'angular-loading-bar/build/loading-bar.min.css';
import 'angular-ui-notification/dist/angular-ui-notification.css';
import 'satellizer/dist/satellizer';
import 'chart.js';
import 'angular-chart.js';
import 'angular-fixed-table-header';
import isMobile from 'ismobilejs';
import 'angular-ismobile';
import 'ngPrint/ngPrint';
import 'angular-paging';
import 'ngclipboard';
import 'v-accordion';
import 'v-accordion/dist/v-accordion.min.css';
import 'angular-file-saver';
import ngTranslate from 'angular-translate';
import 'angucomplete-alt';
import 'angucomplete-alt/angucomplete-alt.css';
import 'ng-loading-overlay';

import "../assets/table.css";
import "../assets/animate.css";
import "../assets/newtemplate.css";
import "../assets/mobile.css";
import "../assets/printstyle.css";
import "../assets/overlay.css";

let api_host = window.location.origin;

export const PaymentOnTrial = 'T';
export const PaymentFailed = 'F';
export const PaymentSucceeded = 'C';
export const PaymentDisputing = 'X';
export const PaymentRegistered = 'R';
export const PaymentUnregistered = 'U';
export const PaymentCanceled = 'Z';

angular.module('app', [
    uiRouter,
    uiBootstrap,
    Components,
    Pages,
    Services,
    Directives,
    ngMoment,
    ngAnimate,
    ngNotify,
    ngSanitize,
    ngCsv,
    ngTranslate,
    'validation',
    'validation.rule',
    'moment-picker',
    'angularFileUpload',
    'mwl.confirm',
    'angular.filter',
    'angular-loading-bar',
    'satellizer',
    'chart.js',
    'fixed.table.header',
    'ismobile',
    'bw.paging',
    'ngclipboard',
    'vAccordion',
    'ngFileSaver',
    'angucomplete-alt',
    'ngLoadingOverlay'
])
    .constant('ignoredForOverlay', [
        'pending-invitations',
        'closing-hour',
        'cashier-sales',
        'orders',
        'sessions',
        'cashiers',
        'profiles'
    ])
    .factory('AuthInterceptor', ($q, $injector) => {
        "ngInject";
        return {
            request: (config) => {
                let AuthService = $injector.get('AuthService');
                const $loadingOverlay = $injector.get('$loadingOverlay');
                const shouldShowOverlay = !$injector.get('ignoredForOverlay').some(url => config.url.includes(url));
                let token = AuthService.getToken();
                let accToken = AuthService.getAccountToken();
                if (config.url.indexOf('/api/') > -1 && token) {
                    config.headers.Authorization = 'Bearer ' + token;
                }
                if (config.url.indexOf('/api/') > -1 && accToken) {
                    config.headers['X-Account-Token'] = accToken;
                }
                if(shouldShowOverlay || config.method !== "GET"){
                    $loadingOverlay.show();
                }
                return config;
            },
            response: (res) => {
                let AuthService = $injector.get('AuthService');
                const $loadingOverlay = $injector.get('$loadingOverlay');
                if (res.data.access_token) {
                    AuthService.saveToken(res.data.access_token);
                    delete res.data.access_token;
                }
                $loadingOverlay.hide();
                return res;
            }
        };
    })
    .factory('ErrorInterceptor', ($q, $injector) => {
        "ngInject";
        return {
            request: function (config) {
                return config || $q.when(config);
            },
            responseError: (resp) => {
                var notify = $injector.get('Notification');
                var $state =  $injector.get('$state');
                var excep = $injector.get('ExceptionsService');
                const permissionService = $injector.get('ProfilePermissionsService');
                const _ = $injector.get('$translate').instant;
                const $loadingOverlay = $injector.get('$loadingOverlay');

                if (resp && resp.status && resp.status == 401) {
                    notify.info(_('Su sesión ha expirado.'));
                    $state.go('login');

                    return $q.reject(resp);
                }

                if (resp && resp.data && resp.data.code) {
                    if (resp.data.code === 'PAYMENT_PENDING') {
                        if (![PaymentOnTrial, PaymentRegistered, PaymentSucceeded].includes(resp.data.payment_status)) {
                            if (permissionService.hasPermission('manage-subscription')) {
                                $state.go(
                                    resp.data.payment_status === PaymentUnregistered ? 'accountSubscription' : 'accountInformation',
                                    { activeTab: 3 }
                                );
                            } else {
                                localStorage.removeItem('accToken');
                                localStorage.removeItem('accPayStatus');
                                localStorage.removeItem('currentProfile');

                                $state.go('paymentNotice');
                            }
                        }

                        return $q.reject(resp);
                    }

                    notify.error(excep.getErrorMessage(resp.data.code));
                } else if (resp && resp.data && resp.data.msg) {
                    notify.error(resp.data.msg);
                } else if (resp && resp.data && resp.data.errors) {
                    notify.error(_('El formulario no ha podido ser validado, intente nuevamente.'));
                } else {
                    notify.error(_("Ha ocurrido un error con nuestros servidores, estará siendo resuelto en la mayor brevedad posible."));
                }

                $loadingOverlay.hide();
                return $q.reject(resp);
            }
        };
    })
    .factory('PaymentNotificationInterceptor', ($q, $injector) => {
        "ngInject";
        return {
            request: (config) => {
                return config || $q.when(config);
            },
            response: (resp) => {
                const notify = $injector.get('Notification');
                const suscriptionService = $injector.get('SubscriptionService');
                const localStorage = $injector.get('$window').localStorage;

                const status = resp.data.payment_status;
                const trialPeriodEnding = resp.data.on_trial_until || undefined;
                if (status) {
                    localStorage.accPayStatus = status;
                    localStorage.trialPeriodEnding = trialPeriodEnding;

                    suscriptionService.updatePaymentStatus(status);
                }

                return resp;
            }
        }
    })
    .value('host', api_host)
    .component('app', AppComponent)
    .constant('moment', momentTz)
    .filter('capitalise', () => {
        return (token) => {
            return token.split(' ').map(word => word.replace(/\b\w/g, l => l.toUpperCase())).join(' ')
        }
    })
    .config(($locationProvider, $validationProvider, $httpProvider, $stateProvider, $urlRouterProvider, cfpLoadingBarProvider, NotificationProvider, $authProvider, ChartJsProvider, $windowProvider, $translateProvider, $compileProvider, $loadingOverlayConfigProvider) => {
        "ngInject";

        const enTranslation = require('./translations/en.json')
        const esTranslation = require('./translations/es.json')
        const frTranslation = require('./translations/fr.json')
        
        var _window = $windowProvider.$get();
        _window.isMobile = isMobile;

        $loadingOverlayConfigProvider.defaultConfig(`<!-- 1 -->
        <div class="loader loader--style1" title="Loading...">
         <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          width="40px" height="40px" viewBox="0 0 40 40" enable-background="new 0 0 40 40" xml:space="preserve">
         <path opacity="0.2" fill="#FF" d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946
           s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634
           c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"/>
         <path fill="#000" d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0
           C22.32,8.481,24.301,9.057,26.013,10.047z">
           <animateTransform attributeType="xml"
             attributeName="transform"
             type="rotate"
             from="0 20 20"
             to="360 20 20"
             dur="0.5s"
             repeatCount="indefinite"/>
           </path>
         </svg>
        </div>`)

        $translateProvider
            .translations('es', esTranslation)
            .translations('en', enTranslation)
            .translations('fr', frTranslation)
            .useSanitizeValueStrategy('escape')
            .uniformLanguageTag('bcp47')
            .determinePreferredLanguage(() => {
                const locale = window.localStorage.userLanguage || window.navigator.language.split('-')[0]
                return locale.toLowerCase();            
            })
            .fallbackLanguage('es')

        $locationProvider.html5Mode(true).hashPrefix('!');
        $validationProvider.showSuccessMessage = false;
        $httpProvider.interceptors.push('AuthInterceptor');
        $httpProvider.interceptors.push('ErrorInterceptor');
        $httpProvider.interceptors.push('PaymentNotificationInterceptor');

        $validationProvider.setExpression({
            phone: /^$|^(\d{3}-?\d{3}-?\d{4})/,
            url: /^$|((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/,
            email: /^$|^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/,
        });
        $validationProvider.setDefaultMsg({
            required: {
                error: 'Este campo es requerido'
            },
            url: {
                error: 'Debe digitar una URL valida'
            },
            email: {
                error: 'Debe digitar un correo valido'
            },
            phone: {
                error: 'Formato valido: 809-555-5555'
            },
            number: {
                error: 'Debe digitar solo números'
            },
            minlength: {
                error: 'Debe ser un dígito mayor'
            },
            maxlength: {
                error: 'Debe ser un dígito menor'
            },
        });

        $validationProvider.setValidMethod('watch');

        $validationProvider.setErrorHTML(function (msg, element, attrs) {
            return `<span class="text-danger text_danger_position animated fadeIn">${msg}</span>`;
        });
        $urlRouterProvider.otherwise(($injector, $location) => {
            if ($location.path().toLowerCase() === '/') {
                if (Object.keys($location.search()).length > 0) return;
                return '/login';
            }
            return '/404';
        });

        cfpLoadingBarProvider.includeSpinner = false;

        NotificationProvider.setOptions({
            startTop: 85
        });

        $authProvider.google({
            url: api_host + '/api/auth/google',
            clientId: '1092965499756-3cgtbkcq1a4mfpbojplhq4clgnpgb3go.apps.googleusercontent.com'
        });
        _window.stripe = _window.Stripe('pk_live_E9pFvsJq3tK84bYXYORZGn6l');
        $compileProvider.debugInfoEnabled(false);

        // if ('serviceWorker' in navigator) {
        //     navigator.serviceWorker.register('service-worker.js')
        //         .then(resp => console.log(`Service Worker registered in ${resp.scope}`));
        // }
    })
    .run(($transitions, amMoment, $window) => {
        "ngInject";

        amMoment.changeLocale(($window.localStorage.userLanguage || $window.navigator.userLanguage || $window.navigator.language).toLowerCase());

        $transitions.onBefore({
            to: (state) => ['paymentNotice', 'profileSelection', 'accountRegistration', 'userControl', 'login', 'pendingInvitations', 'register', 'passwordRequest', 'passwordRecovery', 'recoverySuccess', 'requestSuccess'].indexOf(state.name) === -1
        }, (trans) => {
            var auth = trans.injector().get('AuthService');
            var service = trans.injector().get('ProfilePermissionsService');
            if (!auth.isAuthenticated()){
                return trans.router.stateService.target('login');
            }
            if (!service.hasProfiles()) {
                return trans.router.stateService.target('accountRegistration');
            }
            if (auth.isAuthenticated() && !service.getProfile()) {
                return trans.router.stateService.target('profileSelection');
            }
        });

        $transitions.onBefore({
            to: 'login'
        }, (trans) => {
            var auth = trans.injector().get('AuthService');
            var service = trans.injector().get('ProfilePermissionsService');
            if (auth.isAuthenticated()) {
                if (!!auth.getAccountToken()){
                    let role = auth.getAccountRole();
                    if (role == 'ADMIN' || role == 'MASTER'){
                        return trans.router.stateService.target('userControl');
                    } else {
                        return trans.router.stateService.target('dashboard');
                    }
                } else {
                    if (!service.hasProfiles()) {
                        return trans.router.stateService.target('accountRegistration');
                    }

                    return trans.router.stateService.target('profileSelection');
                }
            }
        });

        $transitions.onBefore({
            to: 'register'
        }, (trans) => {
            var auth = trans.injector().get('AuthService');
            if (auth.isAuthenticated()) {
                return trans.router.stateService.target('dashboard');
            }
        });

        $transitions.onBefore({
            to: (state) => {
                return state.data && state.data.authRequired;
            }
        }, (trans) => {
            var auth = trans.injector().get('AuthService');
            var window = trans.injector().get('$window');
            if (!auth.isAuthenticated()) {
                window.localStorage.removeItem('jwtToken');
                window.localStorage.removeItem('accToken');
                return trans.router.stateService.target('login');
            // } else if (auth.isAuthenticated() && !auth.hasAccount()){
            //     return trans.router.stateService.target('profileSelection');
            }
        });

        $transitions.onBefore({
            to: (state) => {
                return state.data && state.data.authRequired && state.data.adminAccountRequired;
            }
        }, (trans) => {
            let auth = trans.injector().get('AuthService');
            var window = trans.injector().get('$window');
            let role = auth.getAccountRole();
            if (!(role == 'ADMIN' || role == 'MASTER')){
                window.localStorage.removeItem('jwtToken');
                window.localStorage.removeItem('accToken');
                return trans.router.stateService.target('login')
            }
        });

        $transitions.onBefore({
            to: (state) => {
                return state.data && state.data.permsRequired && state.data.permsRequired.length > 0;
            }
        }, (trans) => {
            var service = trans.injector().get('ProfilePermissionsService');
            var notify = trans.injector().get('Notification');
            var $q = trans.injector().get('$q');
            var $state = trans.injector().get('$state');
            var permsRequired = trans.to().data.permsRequired;
            var hasPerm = service.isAdmin() || service.hasAtLeastOneOf(permsRequired);

            if (!hasPerm) {
                if (trans.from() == trans.to()) {
                    return $state.target('dashboard');
                }
                else {
                    notify.warning({
                        message: "No tiene permiso para acceder a esta funcionalidad, contacte a su administrador."
                    });
                    return $q((resolve, reject) => { reject() });
                }
            } else {
                return $q((resolve, reject) => { resolve() });
            }
        });
        $transitions.onBefore({
            to: (state) => {
                return state.data && !state.data.paymentExempt
            }
        }, (trans) => {
            const localStorage = trans.injector().get('$window').localStorage;
            const status = localStorage.getItem('accPayStatus');
            const service = trans.injector().get('ProfilePermissionsService');
            const $state = trans.injector().get('$state');
            let authService = trans.injector().get('AuthService');

            let role = authService.getAccountRole();
            if (role == 'ADMIN' || role == 'MASTER') {
                return $state.target('userControl');
            }

            if (![PaymentOnTrial, PaymentRegistered, PaymentSucceeded].includes(status)) {
                if (service.hasPermission('manage-subscription')) {
                    if (status === PaymentUnregistered) {
                        return $state.target('accountSubscription');
                    }

                    return $state.target('accountInformation', {
                        activeTab: 3
                    });
                } else {
                    localStorage.removeItem('accToken');
                    localStorage.removeItem('accPayStatus');
                    localStorage.removeItem('currentProfile');

                    return $state.target('paymentNotice');
                }
            };

        });
    });



// WEBPACK FOOTER //
// ./src/app/app.js